import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { updateNotificationDestinationSettings } from 'Shared/actions/notifications';
import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';

import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';

function UserNotificationsEmail() {
  const dispatch = useDispatch();
  const notificationDestination = useSelector(state =>
    state.notification_destinations.find(({ slug }) => slug === 'email')
  );

  const handleChange = event => {
    const updatedValues = {
      ...notificationDestination.settings,
      [event.target.name]: !notificationDestination.settings[event.target.name],
    };
    dispatch(
      updateNotificationDestinationSettings({
        notificationDestinationID: notificationDestination.id,
        settings: updatedValues,
      })
    );
  };

  if (!notificationDestination) return null;

  return (
    <WpContainer>
      <WpContainerHeader>
        <h5>Email Notifications</h5>
      </WpContainerHeader>
      <WpContainerBody>
        <p className="mb-4">Customize your email settings</p>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="activity"
            name="activity"
            label="Task Notifications"
            checked={notificationDestination.settings.activity}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Notifies you when new action items or discussion topics are assigned to you, when action items you assigned
            are completed, and when action items are past due
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="comments"
            name="comments"
            label="Comment Notifications"
            checked={notificationDestination.settings.comments}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Receive updates when someone adds a new comment or @mentions you in a comment
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="daily_digest"
            name="daily_digest"
            label="Daily Digest Email"
            checked={notificationDestination.settings.daily_digest}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Sends a Daily Digest email at 5 PM of new and recently completed topics, comments and action items
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="start_day"
            name="start_day"
            label="Your Day Ahead Email"
            checked={notificationDestination.settings.start_day}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Sends a Your Day Ahead email at 9 AM of action items due today and 1:1s today
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="weekly_digest"
            name="weekly_digest"
            label="Weekly Digest"
            checked={notificationDestination.settings.weekly_digest}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Sends a weekly summary on Friday at 4 PM of new and recently completed topics, comments and action items
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="meeting_reminder_one_hour"
            name="meeting_reminder_one_hour"
            label="1:1 reminder one hour in advance"
            checked={notificationDestination.settings.meeting_reminder_one_hour}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Reminds you to prepare for your 1:1 meetings one hour before the meeting
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="meeting_reminder_one_day"
            name="meeting_reminder_one_day"
            label="1:1 reminder one day in advance"
            checked={notificationDestination.settings.meeting_reminder_one_day}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">Reminds you to prepare for your 1:1 meetings one day before the meeting</div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="group_meeting_reminder_one_hour"
            name="group_meeting_reminder_one_hour"
            label="Group meeting reminder one hour in advance"
            checked={notificationDestination.settings.group_meeting_reminder_one_hour}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Reminds you to prepare for your group meetings one hour before the meeting
          </div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="group_meeting_reminder_one_day"
            name="group_meeting_reminder_one_day"
            label="Group meeting reminder one day in advance"
            checked={notificationDestination.settings.group_meeting_reminder_one_day}
            onChange={handleChange}
          />
          <div className="ml-4 text-muted">
            Reminds you to prepare for your group meetings one day before the meeting
          </div>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
}

export default UserNotificationsEmail;
